import { IFetchOptions } from "itsf-ui-common";
import { fetcher } from "@utils/fetcher";
import { INotificationCountResponse } from "@modules/notificationService/interfaces/responses";
import { getWebNotificationCountRoute } from "@api-routes/notifications";

export const getNotificationCount = (options: IFetchOptions = {}) =>
    fetcher<INotificationCountResponse>(getWebNotificationCountRoute(), {
        ...options,
    });
